import { SET_MYFILES, RESET_MYFILES_FILTERS } from '../storeConstant';

const initialState = {
    myFilesData: [],
    resetFilters: false
};


const MyFilesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MYFILES:
            return {
                ...state,
                myFilesData: action.payload
            }
        case RESET_MYFILES_FILTERS:
            return {
                ...state,
                resetFilters: action.payload
            }

        default:
            return state;
    }
}

export default MyFilesReducer;
